import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { GameScene } from '@Core/GameScene/GameScene';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';
import EventsCenter from '@Managers/Events/EventsCenter';
import { ALL_EVENTS_LIST } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { SPECIAL_GAME_CONFIGS_GAMESTORE_KEYS, SPECIAL_GAME_PREFIX_PER_TYPE } from '../../Types/GameStoreTypes/SpecialGames';

export class SpecialGamesTotalWin {
    constructor(
        public readonly scene: GameScene,
        private readonly specialGamesType: ESpecialGamesType
    ) {
        Logger.log(LoggerLevel.Constructor, {
            class: SpecialGamesTotalWin.name,
            source: LoggerSource.Game,
            message: 'SpecialGamesTotalWin constructor'
        });
        EventsCenter.on(ALL_EVENTS_LIST.POST_WIN_STATE, this.syncText, this);

        this.syncText();
    }

    private syncText(): void {
        const specialGamesConfigGameStoreKey = SPECIAL_GAME_CONFIGS_GAMESTORE_KEYS.get(this.specialGamesType)!;
        const config = this.scene.game.gameStore.get(specialGamesConfigGameStoreKey);
        const { totalWin: totalWinvalue } = config;
        const totalWinFormatted = CurrencyUtils.formatRawCurrencyValue(totalWinvalue);
        this.scene.game.gameStore.set(
            EGameStoreKeys.TextVariables,
            { [`${SPECIAL_GAME_PREFIX_PER_TYPE.get(this.specialGamesType)}TotalWin`]: totalWinFormatted },
            true
        );
    }
}
